<template>
  <div>
    <el-row class="page-buttons">
      <editor-button v-if="hasCreatePermission" :disabled="!hasNonLinkedTaskTypes" action="add" @click="handleAdd" />
    </el-row>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column :label="$t(itemLabel)" width="220">
        <template slot-scope="scope">
          <Select
            v-model="scope.row[valueField]"
            :value-field="valueField"
            :label-field="labelField"
            :options="scope.row.options"
            :disabled="disabled"
            @change="handleSelectChange"
          />
        </template>
      </el-table-column>
      <el-table-column
        v-for="boolean in booleans"
        :key="boolean"
        :prop="boolean"
        :label="$t('roleTaskType.' + boolean)"
        width="120"
        align="center"
      >
        <template slot-scope="scope">
          <el-checkbox
            v-model="scope.row[boolean]"
            :disabled="isCheckBoxDisabled(boolean, scope.row)"
            @change="handleCheckboxChange"
          />
        </template>
      </el-table-column>
      <el-table-column v-if="hasDeletePermission" align="center" :label="$t('table.actions')" width="120">
        <template slot-scope="scope">
          <el-button type="danger" icon="el-icon-delete" circle @click="handleDelete(scope.row)" />
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import EditorButton from '@/components/crud/EditorButton';
import Select from '@/components/DSE/Select';
import { hasCreatePermissionForCode } from '@/utils/permission';

export default {
  components: {
    EditorButton,
    Select
  },
  props: {
    value: [Array, Object, String],
    items: {
      type: Array,
      default: () => []
    },
    booleans: {
      type: Array,
      default: () => []
    },
    disabled: {
      default: false,
      type: Boolean
    },
    labelField: {
      default: 'description',
      type: String
    },
    valueField: {
      default: 'id',
      type: String
    },
    itemLabel: {
      default: '',
      type: String
    },
    entity: {
      default: '',
      type: String
    }
  },
  data() {
    return {
      tableData: []
    };
  },
  computed: {
    selectedIDs() {
      const ids = this.tableData.map(row => row.id);
      return ids;
    },
    hasCreatePermission() {
      return hasCreatePermissionForCode(this.entity, this.$store.getters.permissions);
    },
    hasDeletePermission() {
      return this.hasCreatePermission;
    },
    hasNonLinkedTaskTypes() {
      return this.items.length !== this.selectedIDs.length;
    }
  },
  watch: {
    value(value) {
      this.tableData = value;
      this.refreshSelects();
    }
  },
  created() {},
  methods: {
    handleAdd() {
      const firstSelectableItem = this.items.find(item => !this.selectedIDs.includes(item.id));
      if (!firstSelectableItem) {
        return;
      }
      const row = { id: firstSelectableItem.id };
      this.booleans.forEach(boolean => {
        row[boolean] = false;
      });
      this.tableData.push(row);
      this.refreshSelects();
      this.emitValues();
    },
    handleDelete(row) {
      const idx = this.tableData.findIndex(function(elem) {
        return elem.id === row.id;
      });
      if (idx >= 0) {
        this.tableData.splice(idx, 1);
        this.refreshSelects();
        this.emitValues();
      }
    },
    refreshSelects() {
      this.tableData = this.tableData.map(row => ({
        ...row,
        options: this.items.filter(item => row.id === item.id || !this.selectedIDs.includes(item.id))
      }));
    },
    emitValues() {
      this.tableData.forEach(row => {
        if (row.assignYN || row.executeYN || row.createYN) {
          row.readYN = true;
        }
      });
      const values = this.tableData.map(row => {
        const value = { ...row };
        delete value.options;
        return value;
      });
      this.$emit('input', values);
    },
    handleCheckboxChange() {
      this.emitValues();
    },
    handleSelectChange() {
      this.refreshSelects();
      this.emitValues();
    },
    isCheckBoxDisabled(boolean, row) {
      return this.disabled || (boolean === 'readYN' && (row.assignYN || row.executeYN || row.createYN));
    }
  }
};
</script>

<style lang="scss" scoped></style>
